<ng-template #editSearchTemplate let-c="close" let-modal>
  <div *transloco="let r; read: 'searchPanel'" class="container">
    <div class="modal-header">
      <h3 class="modal-title">
        {{ r('editsearch.label') }}
      </h3>
      <rx-button icon="rx-close" class="close" buttonClass="subtle-circle" (click)="c('Cross click')"></rx-button>
    </div>
    <div class="modal-body">
      <ng-container
        *ngTemplateOutlet="
          searchBoxRef;
          context: {
            $implicit: searchBoxType,
            selectedOptions: searchSelectedOptions,
            close: c,
          }
        "
      ></ng-container>
    </div>
  </div>
</ng-template>

<div *transloco="let t; read: 'searchPanel'" class="search-summary-panel">
  <div class="container">
    <div class="d-flex justify-content-md-start justify-content-between">
      <div class="d-flex flex-column flex-md-row search-info" *ngIf="routerFacade.queryParams$ | async as params">
        <div class="d-flex pr-md-3 align-items-center">
          <rx-icon name="search" class="mr-2 search-icon"></rx-icon>
          <span class="searched-name">{{ searchedName }}</span>
        </div>
        <div class="d-flex">
          <span class="pl-md-3 pr-3 check-in-dates">
            {{ params.checkinDate | date: dateFormat }} -
            {{ params.checkoutDate | date: dateFormat }}
          </span>
          <div class="pl-3 pr-3 border-left" *ngIf="occupancyTranslations$ | async as occupancyTranslations">
            <rx-applications-occupancy-shorthand
              [rooms]="params.rooms"
              [translations]="occupancyTranslations"
            ></rx-applications-occupancy-shorthand>
          </div>
        </div>
      </div>
      <div class="d-flex pl-3 border-left align-items-center edit-icon">
        <rx-icon name="edit" (click)="editSearch(editSearchTemplate)" data-qa="search-summary-edit-search"> </rx-icon>
      </div>
    </div>
  </div>
</div>
